import { MouseEvent } from "react";
import { LexicalCommand, REDO_COMMAND, UNDO_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';

import ToggleButtonGroup from "../ToggleButtonGroup";
import ToolbarButton from "../ToolbarButton";
import { useToolbarContext } from "../../ToolbarContext";


export function HistoryButtons() {
    const [editor] = useLexicalComposerContext();
    const { canUndo, canRedo } = useToolbarContext();


    const handleChange = (_event: MouseEvent<HTMLElement>, command: LexicalCommand<void>) => {
        if (!command) {
            console.error("Command is null or undefined.");
            return;
        }

        // dispatch undo/redo command
        editor.dispatchCommand(command, undefined);
    };

    return (
        <ToggleButtonGroup exclusive onChange={handleChange}>
            <ToolbarButton value={UNDO_COMMAND} tooltip="Undo" aria-label="Undo" disabled={!canUndo}>
                <UndoIcon />
            </ToolbarButton>
            <ToolbarButton value={REDO_COMMAND} tooltip="Redo" aria-label="Redo" disabled={!canRedo}>
                <RedoIcon />
            </ToolbarButton>
        </ToggleButtonGroup>
    );
}

export default HistoryButtons;